export default __webpack_public_path__ + "static/media/about-us.a702bef6.png";